<template>
  <base-layout toolbarActive>
    <template #toolbarBase>
      <div v-if="!pollMobile">
        <router-link
          :to="{ name: 'pollCreate' }"
          class="link font-weight-medium"
        >
          <icon-plus></icon-plus> Добавить новый опрос
        </router-link>
      </div>
      <v-layout v-if="pollMobile" justify-space-between align-center>
        <span class="font-weight-bold display-2"> Опросы </span>
        <button class="add-adv">
          <router-link :to="{ name: 'pollCreate' }">
            <icon-plus
              class="mx-2 my-2"
              :color="
                $store.getters.themeDark ? '#FFFFFF' : $vuetify.theme.primary
              "
            ></icon-plus>
          </router-link>
        </button>
      </v-layout>
      <v-flex class="layout justify-end align-center" v-if="!pollMobile">
        <polls-filter></polls-filter>
      </v-flex>
    </template>

    <hint-widget
      hintName="polls"
      type="text"
      class="mx-4 mb-3"
      btnMore
    ></hint-widget>

    <v-container
      class="fluid pt-0"
      :class="{ 'px-0': pollMobile, 'grid-list-xl': !pollMobile }"
    >
      <v-layout wrap>
        <v-expansion-panel
          :value="panel"
          :readonly="!pollMobile"
          expand
          class="pt-2 justify-start"
        >
          <div class="flex md4 sm6 xs12 adv-panel">
            <new-card-for-add :card="newPollCard"></new-card-for-add>
          </div>
          <v-flex
            v-for="(poll, index) in pollsFilteredList"
            :key="poll.id"
            class="md4 sm6 xs12 adv-panel"
            :class="{ 'py-0 px-0 border-dark': pollMobile }"
          >
            <poll-item
              :id="poll.id"
              :index="index"
              class="content-bg--2 fill-height"
            >
            </poll-item>
          </v-flex>
        </v-expansion-panel>
      </v-layout>
    </v-container>
  </base-layout>
</template>
<script>
import PollItem from "../components/polls/PollItem.vue";
import PollsFilter from "../components/polls/PollsFilter";
import BaseLayout from "../components/layout/BaseLayout.vue";
import IconPlus from "../components/icon/IconPlus.vue";
import HintWidget from "../components/common/HintWidget.vue";
import NewCardForAdd from "../components/common/NewCardForAdd.vue";

export default {
  name: "PollsView",

  components: {
    IconPlus,
    BaseLayout,
    PollItem,
    PollsFilter,
    HintWidget,
    NewCardForAdd,
  },
  data: () => ({
    panel: [],
    // информация на карточке создания нового опроса
    newPollCard: {
      title: "Создать новый опрос",
      action: "pollCreate",
      description: "",
    },
  }),
  watch: {
    // отслеживаем Expansion Panel, так как  при удалении из нее itemов она не верно обновляется
    // и из верстки пропадает болшее количество элементов, чем должно
    panel() {
      if (
        !["xs"].includes(this.$vuetify.breakpoint.name) &&
        this.panel.length !==
          this.$store.getters.pollList(this.$store.getters.pollsFilter).length
      )
        this.panel = Array(
          this.$store.getters.pollList(this.$store.getters.pollsFilter).length
        ).fill(true);
    },
    // тоже для Expansion Panel
    pollsFilteredList: function () {
      if (!["xs"].includes(this.$vuetify.breakpoint.name)) {
        this.panel = Array(
          this.$store.getters.pollList(this.$store.getters.pollsFilter).length
        ).fill(true);
      }
    },
  },
  mounted() {
    this.$store.dispatch("pollListLoad");
    if (this.panel.length < this.pollsFilteredList.length) {
      this.panel = Array(
        this.$store.getters.pollList(this.$store.getters.pollsFilter).length
      ).fill(true);
    }
  },
  computed: {
    // для expandPanel, все плашки только для чтения (не сворачиваются)
    pollMobile() {
      return ["xs"].includes(this.$vuetify.breakpoint.name);
    },
    pollsFilteredList() {
      return this.$store.getters.pollList(this.$store.getters.pollsFilter);
    },
  },
};
</script>
